import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { VendaEditPage } from '@/features/venda/page/edit/VendaEditPage';
import { StringToIdpkSchema } from '@/std/schema';

const RouteVendaParamsSchema = z.object({
    action: z.enum(['editar', 'visualizar']),
    idpk: StringToIdpkSchema,
});

export const Route = createFileRoute('/a/venda/$action/$idpk')({
    component: Component,
    params: {
        parse: (params) => {
            const result = RouteVendaParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
});

function Component() {
    const { action, idpk } = Route.useParams();

    return <VendaEditPage idpk={idpk} mode={action} />;
}
